module.exports = __webpack_public_path__ + "img/services-hvac-system.58018d40.png";